import EditMemberContainer from "../containers/EditMemberContainer";

const EditMemberPage = () => {
  return (
    <EditMemberContainer />
  );
};

export default EditMemberPage;
